import { render, staticRenderFns } from "./SenderBasicDataForm.vue?vue&type=template&id=68102eeb&"
import script from "./SenderBasicDataForm.vue?vue&type=script&lang=ts&"
export * from "./SenderBasicDataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports